/* eslint-disable max-len */
import React from 'react';

const MapIcon = () => (
  <svg height="19" viewBox="0 0 19 19" width="19" xmlns="http://www.w3.org/2000/svg">
    <path
      d="m11.5 4.19 5.009-1.996.491-.194v12.884l-5 2v.004l-.418.164-.081.033-.083-.033-.418-.164v-.003l-4.5-1.801-5.5 2.201v-12.895l5-1.993v-.005l.491-.198.009.004.009-.004.491.198v.005l4.5 1.794zm.5.876v10.74l4.006-1.609v-10.75l-4.006 1.62zm-1 10.74v-10.74l-4-1.616v10.75l4 1.607zm-5-1.606v-10.75l-4 1.615v10.74z"
      fill="currentColor"
    />
  </svg>
);

export default MapIcon;
